<template>
  <div
    v-if="originalMessage"
    data-testid="original-message-section"
    class="rounded-lg border border-neutral-200 bg-neutral-100 p-3"
  >
    <h4 class="text-xs font-medium text-neutral-700 mb-1">Origineel bericht</h4>
    <div class="text-sm text-neutral-600 markdown-content">
      <span class="italic">"<span v-html="renderedMessage"></span>"</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { renderMarkdown } from '@/utils/markdown';

interface Props {
  originalMessage?: string;
}

const props = defineProps<Props>();

const renderedMessage = computed(() => {
  const rendered = renderMarkdown(props.originalMessage || '');
  // Remove wrapping <p> tags and trim to avoid extra newlines
  return rendered.replace(/^<p>(.*)<\/p>\s*$/s, '$1').trim();
});
</script>
